"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  latitudeCenter: 40.714599,
  longitudeCenter: -74.002791,
  zoomValue: 9
};
exports["default"] = _default;